import React from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { VolumesSection } from './components/VolumesSection';
import { BonusesSection } from './components/BonusesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="w-full bg-cream font-sans text-charcoal" data-id="element-0" data-mp="2wip5j08ate3v">
      <Hero data-id="element-1" data-mp="28tme50nv46w6" />
      <main data-id="element-2" data-mp="28t4mkhc5agul">
        <PainSection data-id="element-3" data-mp="28suveqfd63nb" />
        <SolutionSection data-id="element-4" data-mp="28s2xva27hvue" />
        <VolumesSection data-id="element-5" data-mp="23vkzqt1dsvr1" />
        <BonusesSection data-id="element-6" data-mp="23u9v6r043jyv" />
        <TestimonialsSection data-id="element-7" data-mp="23v2s7099qv3t" />
        <OfferSection data-id="element-8" data-mp="3ijxnsm94vshs" />
        <GuaranteeSection data-id="element-9" data-mp="3ikh5q2ysagvt" />
        <FaqSection data-id="element-10" data-mp="3ij61y35c994p" />
        <FinalCtaSection data-id="element-11" data-mp="3ihv22ef0kliv" />
      </main>
      <Footer data-id="element-12" data-mp="3ml14faz09sk2" />
    </div>;
}